import { API_BASE } from "../../../consts";
import authService from "../../../services/AuthService";

const api = (path, opts) => authService.authenticatedFetch(`${API_BASE}${path}`, opts);
const jsonOrThrow = async (resp) => {
    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
        const err = new Error(data.message || data.error || `Request failed: ${resp.status}`);
        err.status = resp.status;
        err.detail = data.detail;
        throw err;
    }
    return data;
};

// First page (or a changed filter): pass filters, omit cursor.
// "Load more": pass only { cursor } — the opaque string from the
// previous response's next_cursor — everything else is ignored since
// Walmart's cursor already encodes the original filters.
export const listReturns = ({
    status, returnType, isWfs, returnOrderId, customerOrderId, cursor, limit = 20,
} = {}) => {
    const params = new URLSearchParams();
    if (cursor) {
        params.set("cursor", cursor);
    } else {
        params.set("limit", limit);
        if (status) params.set("status", status);
        if (returnType) params.set("return_type", returnType);
        if (isWfs) params.set("is_wfs", isWfs);
        if (returnOrderId) params.set("return_order_id", returnOrderId);
        if (customerOrderId) params.set("customer_order_id", customerOrderId);
    }
    return api(`/api/returns?${params}`).then(jsonOrThrow);
};

export const getReturnDetail = (returnOrderId) => api(`/api/returns/${returnOrderId}`).then(jsonOrThrow);

// refundLines: [{ returnOrderLineNumber, quantity?: { unitOfMeasure, measurementValue } }]
export const issueRefund = (returnOrderId, customerOrderId, refundLines) =>
    api(`/api/returns/${returnOrderId}/refund`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            customer_order_id: customerOrderId,
            refund_lines: refundLines.map((l) => ({
                return_order_line_number: l.returnOrderLineNumber,
                ...(l.quantity ? {
                    quantity: {
                        unit_of_measure: l.quantity.unitOfMeasure || "EA",
                        measurement_value: l.quantity.measurementValue,
                    },
                } : {}),
            })),
        }),
    }).then(jsonOrThrow);

export const getImageBySku = (sku) =>
    api("/api/catalog/image-by-sku", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sku }),
    }).then(jsonOrThrow);